import React from 'react'
import { initializeApollo } from '@gql/client'
import { AllCaratteristicheDocument, PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { CertificazioniHubTemplate } from '@components/templates'

const CertificazioniPage = ({ pagina, certificazioni, paginaParent }) => (
  <CertificazioniHubTemplate pagina={pagina} certificazioni={certificazioni} paginaParent={paginaParent}/>
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
        data: { pagina: paginaParent },
      } = await client.query({
        query: PaginaDocument,
        variables: { chiave: 'sostenibilita', preview, withMenuChildren: true },
        context: {
          headers,
        },
      })

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'certificazioni', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { allCaratteristiche: certificazioni },
    } = await client.query({
      query: AllCaratteristicheDocument,
      context: {
        headers,
      },
    })

    return {
      props: { pagina, certificazioni, paginaParent },
      revalidate: 60 * 20,
    }
  },
  '/sostenibilita/certificazioni'
)

export default CertificazioniPage
